export default "__VITE_ASSET__Q53T$Jko__"